import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, registerField } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './unidadeForm';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvar, excluir, getLista, salvarSimulacao } from './unidadeActions';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInput from '../common/form/labelAndInput';
import ContentCardFooter from '../common/template/contentCardFooter';

class UnidadeSimulacao extends Component {

	state = {
		registro: null
	}

	componentWillMount() {
		this.props.getLista(this.props.id_empreendimento);
	}

	render() {

		const valorBase = this.state.registro ? parseFloat(this.state.registro.preco_avista || 0) : 0;
		const valorEntrada = this.state.registro ? (parseFloat(this.state.registro.percentual_entrada || 0) * valorBase) / 100.0 : 0;

		const percentualReajusteMes = 0.007;

		// const parcelas = this.state.registro ? this.state.registro.parcelas || 0 : 0;
		
		let valorSaldo = valorBase - valorEntrada;

		let valorReforco1 = this.state.registro ? (parseFloat(this.state.registro.percentual_reforco1 || 0) * valorBase) / 100.0 : 0;
		valorSaldo -= valorReforco1;
		for (let mes = 1; mes <= 6; mes++) {
			valorReforco1 += valorReforco1 * percentualReajusteMes;
		}
		let valorReforco2 = this.state.registro ? (parseFloat(this.state.registro.percentual_reforco2 || 0) * valorBase) / 100.0 : 0;
		valorSaldo -= valorReforco2;
		for (let mes = 1; mes <= 12; mes++) {
			valorReforco2 += valorReforco2 * percentualReajusteMes;
		}
		let valorReforco3 = this.state.registro ? (parseFloat(this.state.registro.percentual_reforco3 || 0) * valorBase) / 100.0 : 0;
		valorSaldo -= valorReforco3;
		for (let mes = 1; mes <= 18; mes++) {
			valorReforco3 += valorReforco3 * percentualReajusteMes;
		}
		let valorReforco4 = this.state.registro ? (parseFloat(this.state.registro.percentual_reforco4 || 0) * valorBase) / 100.0 : 0;
		valorSaldo -= valorReforco4;
		for (let mes = 1; mes <= 24; mes++) {
			valorReforco4 += valorReforco4 * percentualReajusteMes;
		}
		
		/*let listaParcelas = [];
		let valorTotalParcelas = 0;
		if (this.state.registro) {
			for (let mes = 1; mes <= parcelas; mes++) {
				valorSaldo += valorSaldo * percentualReajusteMes;
				const valorParcela = mes == parcelas ? valorSaldo : parseFloat((valorSaldo / (parcelas - (mes  - 1))).toFixed(2));
				valorSaldo -= valorParcela;

				valorTotalParcelas += valorParcela;

				listaParcelas.push({
					parcela: `Parcela ${mes}:`,
					valor: valorParcela
				})
			}
		}*/

		let valorTotalParcelas12 = 0;
		let valorSaldo12 = valorSaldo;				
		if (this.state.registro) {
			for (let mes = 1; mes <= 12; mes++) {
				valorSaldo12 += valorSaldo12 * percentualReajusteMes;
				const valorParcela = mes == 12 ? valorSaldo12 : parseFloat((valorSaldo12 / (12 - (mes  - 1))).toFixed(2));
				valorSaldo12 -= valorParcela;
				valorTotalParcelas12 += valorParcela;
			}
		}
		
		let valorTotalParcelas24 = 0;
		let valorSaldo24 = valorSaldo;
		if (this.state.registro) {
			for (let mes = 1; mes <= 24; mes++) {
				valorSaldo24 += valorSaldo24 * percentualReajusteMes;
				const valorParcela = mes == 24 ? valorSaldo24 : parseFloat((valorSaldo24 / (24 - (mes  - 1))).toFixed(2));
				valorSaldo24 -= valorParcela;
				valorTotalParcelas24 += valorParcela;
			}
		}
		
		let valorTotalParcelas36 = 0;
		let valorSaldo36 = valorSaldo;
		if (this.state.registro) {
			for (let mes = 1; mes <= 36; mes++) {
				valorSaldo36 += valorSaldo36 * percentualReajusteMes;
				const valorParcela = mes == 36 ? valorSaldo36 : parseFloat((valorSaldo36 / (36 - (mes  - 1))).toFixed(2));
				valorSaldo36 -= valorParcela;
				valorTotalParcelas36 += valorParcela;
			}
		}
		
		let valorTotalParcelas48 = 0;
		let valorSaldo48 = valorSaldo;
		if (this.state.registro) {
			for (let mes = 1; mes <= 48; mes++) {
				valorSaldo48 += valorSaldo48 * percentualReajusteMes;
				const valorParcela = mes == 48 ? valorSaldo48 : parseFloat((valorSaldo48 / (48 - (mes  - 1))).toFixed(2));
				valorSaldo48 -= valorParcela;
				valorTotalParcelas48 += valorParcela;
			}
		}
		
		let valorTotalParcelas60 = 0;
		let valorSaldo60 = valorSaldo;
		if (this.state.registro) {
			for (let mes = 1; mes <= 60; mes++) {
				valorSaldo60 += valorSaldo60 * percentualReajusteMes;
				const valorParcela = mes == 60 ? valorSaldo60 : parseFloat((valorSaldo60 / (60 - (mes  - 1))).toFixed(2));
				valorSaldo60 -= valorParcela;
				valorTotalParcelas60 += valorParcela;
			}
		}

		let valorTotalSafra3 = 0;
		let valorSaldoSafra3 = valorSaldo;				
		if (this.state.registro) {
			for (let mes = 1; mes <= 36; mes++) {
				valorSaldoSafra3 += valorSaldoSafra3 * percentualReajusteMes;
				if (mes == 12) {
					const valorParcela = parseFloat((valorSaldoSafra3 / 3).toFixed(2));
					valorSaldoSafra3 -= valorParcela;
					valorTotalSafra3 += valorParcela;
				}
				if (mes == 24) {
					const valorParcela = parseFloat((valorSaldoSafra3 / 2).toFixed(2));
					valorSaldoSafra3 -= valorParcela;
					valorTotalSafra3 += valorParcela;
				}
				if (mes == 36) {
					const valorParcela = valorSaldoSafra3;
					valorSaldoSafra3 -= valorParcela;
					valorTotalSafra3 += valorParcela;
				}
			}
		}
		
		return (
			<div>
				<Content>
					<ContentCard>
						<ContentCardBody>
							<Row alignCenter>
								<Select
									options={this.props.lista.map(item => ({ id: item.id, valor: item.numero }))}
									label='Lote'
									cols='12 12 8 4'
									placeholder='Selecione'
									value={this.state.registro ? this.state.registro.id_unidade : null}
									onChange={value => {
										const unidade = this.props.lista.filter(item => item.id == value)[0];
										this.setState({
											registro: {
												...unidade,
												numero_lote: unidade.numero,
												percentual_entrada: 20,
												percentual_reforco1: 5,
												percentual_reforco2: 5,
												percentual_reforco3: 5,
												percentual_reforco4: 5
											}
										});
									}} />
							</Row>

							{this.state.registro &&
								<>
									<Row alignCenter>
										<LabelAndInputNumber
											label='Entrada (%)' placeholder='Informe'
											cols='12 6 4 2'
											casas={0}
											value={this.state.registro.percentual_entrada}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														percentual_entrada: data.target.value
													}
												});
											}} />

										<LabelAndInputNumber
											label='Entrada (R$)' placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorEntrada, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>

									<Row alignCenter>
										<LabelAndInputNumber
											label='Reforço 6º mês (%)' placeholder='Informe'
											cols='12 6 4 2'
											casas={0}
											value={this.state.registro.percentual_reforco1}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														percentual_reforco1: data.target.value
													}
												});
											}} />

										<LabelAndInputNumber
											label='Reforço 6º mês (R$)' placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorReforco1, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>

									<Row alignCenter>
										<LabelAndInputNumber
											label='Reforço 12º mês (%)' placeholder='Informe'
											cols='12 6 4 2'
											casas={0}
											value={this.state.registro.percentual_reforco2}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														percentual_reforco2: data.target.value
													}
												});
											}} />

										<LabelAndInputNumber
											label='Reforço 12º mês (R$)' placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorReforco2, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>

									<Row alignCenter>
										<LabelAndInputNumber
											label='Reforço 18º mês (%)' placeholder='Informe'
											cols='12 6 4 2'
											casas={0}
											value={this.state.registro.percentual_reforco3}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														percentual_reforco3: data.target.value
													}
												});
											}} />

										<LabelAndInputNumber
											label='Reforço 18º mês (R$)' placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorReforco3, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>

									<Row alignCenter>
										<LabelAndInputNumber
											label='Reforço 24º mês (%)' placeholder='Informe'
											cols='12 6 4 2'
											casas={0}
											value={this.state.registro.percentual_reforco4}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														percentual_reforco4: data.target.value
													}
												});
											}} />

										<LabelAndInputNumber
											label='Reforço 24º mês (R$)' placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorReforco4, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>
									<Row alignCenter>
										<Grid cols='12 6 4 2'>
											<label>Valor da Parcela Média</label>
										</Grid>
									</Row>
									<Row alignCenter>

										<LabelAndInputNumber
											label={`Parcela 60x (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas60 / 60, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />

										<LabelAndInputNumber
											label={`Parcela 48x (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas48 / 48, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>
									<Row alignCenter>										
										<LabelAndInputNumber
											label={`Parcela 36x (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas36 / 36, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />

										<LabelAndInputNumber
											label={`Parcela 24x (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas24 / 24, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />																			
									</Row>
									<Row alignCenter>
										<LabelAndInputNumber
											label={`Parcela 12x (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas12 / 12, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />

										<LabelAndInputNumber
											label={`3 Safras (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalSafra3 / 3, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>
									<Row alignCenter>
										<LabelAndInput
											label={`CPF`}
											placeholder='Informe'
											cols='12 12 8 4'
											value={this.state.registro.cpf}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														cpf: data.target.value
													}
												});
											}} />
									</Row>
									<Row alignCenter>
										<LabelAndInput
											label={`Nome`}
											placeholder='Informe'
											cols='12 12 8 4'
											value={this.state.registro.nome}
											onChange={data => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														nome: data.target.value
													}
												});
											}} />
									</Row>

									{/*<Row>
										<Select
											options={[
												{ id: 60, valor: '60 parcelas' }, { id: 48, valor: '48 parcelas' }, { id: 36, valor: '36 parcelas' },
												{ id: 24, valor: '24 parcelas' }, { id: 12, valor: '12 parcelas' }
											]}
											label='Parcelas'
											cols='12 12 8 4'
											placeholder='Selecione o tipo'
											value={this.state.registro.parcelas}
											onChange={value => {
												this.setState({
													...this.state,
													registro: {
														...this.state.registro,
														parcelas: value
													}
												});
											}} />

									</Row>*/}
									{/*listaParcelas.length > 0 &&
									<Row>										
										<LabelAndInputNumber
											label={`Parcela Média (R$)`}
											placeholder='Informe'
											cols='12 6 4 2'
											casas={2}
											value={FormatUtils.formatarValorTela(valorTotalParcelas / listaParcelas.length, 2)}
											readOnly={'readOnly'}
											onChange={data => { }} />
									</Row>*/}
									{/*listaParcelas.length > 0 &&
									<Row>
										{listaParcelas.map(item => 
											<LabelAndInputNumber
												key={item.parcela}
												label={`${item.parcela} (R$)`}
												placeholder='Informe'
												cols='12 6 4 2'
												casas={2}
												value={FormatUtils.formatarValorTela(item.valor, 2)}
												readOnly={'readOnly'}
												onChange={data => { }} />
										)}
									</Row>*/}
								</>}
						</ContentCardBody>							
						
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='12 6 4 2'>
									<Button
										text='Imprimir'
										type={'primary'}
										icon={'fa fa-chevron-left'}
										disabled={!this.state.registro 
											|| !this.state.registro.id
											|| parseFloat(this.state.registro.percentual_entrada) <= 0
											|| !this.state.registro.cpf
											|| !this.state.registro.nome
										}
										event={() => {
											if (this.state.registro 
												&& this.state.registro.id
												&& parseFloat(this.state.registro.percentual_entrada) > 0
												&& this.state.registro.cpf
												&& this.state.registro.nome
											) {
												this.props.salvarSimulacao({
													...this.state.registro,
													id_unidade: this.state.registro.id,
													valorAVista: FormatUtils.formatarValorTelaDecimal(this.state.registro.preco_avista, 2),
													percentualEntrada: FormatUtils.formatarValorTela(this.state.registro.percentual_entrada, 0),
													valorEntrada: FormatUtils.formatarValorTelaDecimal(valorEntrada, 2),
													percentualReforco1: FormatUtils.formatarValorTela(this.state.registro.percentual_reforco1, 0),
													valorReforco1: FormatUtils.formatarValorTelaDecimal(valorReforco1, 2),
													percentualReforco2: FormatUtils.formatarValorTela(this.state.registro.percentual_reforco2, 0),
													valorReforco2: FormatUtils.formatarValorTelaDecimal(valorReforco2, 2),
													percentualReforco3: FormatUtils.formatarValorTela(this.state.registro.percentual_reforco3, 0),
													valorReforco3: FormatUtils.formatarValorTelaDecimal(valorReforco3, 2),
													percentualReforco4: FormatUtils.formatarValorTela(this.state.registro.percentual_reforco4, 0),
													valorReforco4: FormatUtils.formatarValorTelaDecimal(valorReforco4, 2),
													valorTotalParcelas60: FormatUtils.formatarValorTelaDecimal(valorTotalParcelas60 / 60, 2),
													valorTotalParcelas48: FormatUtils.formatarValorTelaDecimal(valorTotalParcelas48 / 48, 2),
													valorTotalParcelas36: FormatUtils.formatarValorTelaDecimal(valorTotalParcelas36 / 36, 2),
													valorTotalParcelas24: FormatUtils.formatarValorTelaDecimal(valorTotalParcelas24 / 24, 2),
													valorTotalParcelas12: FormatUtils.formatarValorTelaDecimal(valorTotalParcelas12 / 12, 2),
													valorTotalSafra3: FormatUtils.formatarValorTelaDecimal(valorTotalSafra3 / 3, 2)
												});
											}
										}} />
								</Grid>
								<Grid cols='12 6 4 2'>
									<Button
										text='Limpar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => {
											this.setState({
												registro: {
													percentual_entrada: 20,
													percentual_reforco1: 5,
													percentual_reforco2: 5,
													percentual_reforco3: 5,
													percentual_reforco4: 5
												}
											});
										}} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</ContentCard>
				</Content>
			</div>
		)
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.unidade,
	modoTela: state.unidade.modoTela,
	lista: state.unidade.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, salvarSimulacao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeSimulacao);
